import { render, staticRenderFns } from "./DbManagePanel.vue?vue&type=template&id=7fc4fda1&scoped=true&"
import script from "./DbManagePanel.vue?vue&type=script&lang=ts&"
export * from "./DbManagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DbManagePanel.vue?vue&type=style&index=0&id=7fc4fda1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc4fda1",
  null
  
)

export default component.exports